angular.module('jv.requisition.notes.controller', [])
    .controller('ReqsNotesCtrl', ['$scope', '$route', 'Reqs', '$window',
function ($scope, $route, Reqs, $window) {

    // Private variable
    var options;

    $scope.flags.loading = true;
    $scope.requisitions.paging = {
        page: 0,
        pageLimit: 10
    };
    $scope.requisitions.notes = [];
    $scope.note = {
        to: ''
    };
    /* Used by chosen in the AJAX formatting callback */
    $scope.formatter = Reqs.emailFormatter;

    /*
     * setting flag for draft state of the requisition note.
     */
    $scope.reqNote = {};
    $scope.reqNote.inDraft = false;
    /*
     * Max number results / notes to be fetched.
     */
    $scope.maxCount = 20;
    //Method for refreshing the notes list
    $scope.refresh = function () {
        var data = {};
        Reqs.getNotesCount($scope.params.id, function (response) {
            if (response.notesCount > 0) {
                data = {
                    id: $scope.params.id,
                    offset: 0,
                    count: $scope.maxCount
                };
                Reqs.notes(data, function (response) {
                    angular.extend($scope.requisitions, response);
                    if (response.tabIndex !== 4) {
                        $scope.routeRequest($scope.params, response.tabIndex);
                    }
                    $scope.flags.loading = false;
                });
            }
            $scope.$parent.requisitions.notesCount = response.notesCount;
            $scope.flags.loading = false;
        });

    };

    // Bootstrapping the Notes section.
    if ($scope.$parent.tabClicked === 'notes') { // On click of tab
        $scope.refresh();
    } else if ($scope.activeTab('#/notes')) { // On pagination or On Refresh
        options = angular.extend({
            paginated: $scope.flags.paginated
        }, $scope.params);
        /*Restricting the request if params is empty*/
        if (!$.isEmptyObject($scope.params)) {
            Reqs.details(options, function (requisition) {
                angular.extend($scope.requisitions, requisition);
                if ($scope.requisitions.forumBaseUrl) {
                    $scope.$root.forumBaseUrl = $scope.requisitions.forumBaseUrl;
                }
                $scope.params.id = $scope.requisitions.jobDetails.EId;
                $scope.refresh();
            });
        }
    }
    /*
     * Watching the tinymce wrapped text-area to set draft flag
     */
    $scope.$watch('note.content', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            $scope.reqNote.inDraft = true;
        }
    });
    
    /*
     * This function makes the form pristine(setting to initial state of the form).
     */
    var makePristine = function (formCtrl, elem) {
        if (formCtrl && formCtrl.$name) {
            // var name = $filter('uppercase')(formCtrl.$name.charAt(0)) + formCtrl.$name.substr(1);
            if (elem) {
                // new version of angular has $setPristine, use when available
                if (formCtrl.$setPristine) {
                    formCtrl.$setPristine();
                } else {
                    elem.removeClass('ng-dirty').addClass('ng-pristine');
                    formCtrl.$pristine = true;
                    formCtrl.$dirty = false;
                    angular.forEach(elem.find('.ng-dirty'), function (el) {
                        var inputCtrl = $(el).data('$ngModelController');
                        if (inputCtrl) {
                            inputCtrl.$pristine = true;
                            inputCtrl.$dirty = false;
                        }
                        $(el).removeClass('ng-dirty').addClass('ng-pristine');
                    });
                }
            }

        }
    };
    
     /*
     * Loads one note which latest.
     */
    var loadLatestNote = function () {
        var data = {
            offset: 0,
            count: 1,
            id: $scope.params.id,
            latest: true
        };

        $scope.flags.loading = true;
        Reqs.notes(data, function (response) {
            $scope.requisitions.notes = response.notes.concat($scope.requisitions.notes);
            $scope.flags.loading = false;
        });
    };

    //Method for adding the note
    $scope.add = function () {
        if (($scope.note.toOthers && $scope.note.to.length === 0) || !$scope.note.subject || $scope.note.subject.length > 150 || !$scope.note.content) {
            $scope.validationError = true;
            return;
        }
        $scope.flags.loading = true;

        // If 'Send to Others' is unchecked do not send any email addresses.
        if (!$scope.note.toOthers) {
            $scope.note.to = '';
        }
        Reqs.addNote($scope.params.id, $scope.note, function (data) {
            $scope.flags.loading = false;
            if (data.msgInfo === $scope.status.OK) {
                if ($scope.note.toOthers && $scope.note.to.length !== 0) {
                    $scope.showMsg('NOTE_SENT');
                } else {
                    $scope.showMsg('NOTE_ADDED');
                }
                $scope.cancel(true);
                $scope.$parent.requisitions.notesCount++;
                if ($scope.activeTab('notes')) {
                    loadLatestNote();
                }
                if ($scope.activeTab('#/activities')) {
                    $route.reload();
                }
            } else {
                $scope.showMsg('REQ_NOTE_ADD_ERROR');
            }
        });
    };

    var clearTinyMCE = function () {
        if ($window.tinyMCE && $window.tinyMCE.activeEditor && $window.tinyMCE.activeEditor.getContent()) {
            $window.tinyMCE.activeEditor.setContent('');
        }
    };

    //Method for reseting the form values
    $scope.cancel = function (canFlag) {
        if (canFlag) {
            $scope.note = {
                to: ''
            };
            $scope.attachClear();
            if ($scope.reqNotesForm.$dirty) {
                var form = $scope.reqNotesForm;
                makePristine(form, $('form[name="reqNotesForm"]')); //passing the form model & element as parameter.
                $scope.reqNote.inDraft = false;
            }
            clearTinyMCE();
        }
        /*
         * Make the edited form in draft state.
         */
        else {
            if ($scope.reqNotesForm.$dirty) {
                $scope.reqNote.inDraft = true;
            }
        }
        $scope.validationError = false;
        $scope.toggleAddNoteForm();
    };
    $scope.$parent.notesCancel = $scope.cancel; // Attaching Notes' cancel method to ReqsTabsCtrl To Check For Pagination

    //For prev link
    $scope.prev = function () {
        if ($scope.requisitions.paging.page > 0) {
            $scope.requisitions.paging.page--;
            $scope.refresh();
        }
    };

    //For next link
    $scope.next = function () {
        if ($scope.requisitions.paging.page < ($scope.$parent.requisitions.notesCount / $scope.requisitions.paging.pageLimit)) {
            $scope.requisitions.paging.page++;
            $scope.refresh();
        }
    };

    $scope.recordsStart = function () {
        return $scope.requisitions.paging.pageLimit * $scope.requisitions.paging.page + 1;
    };

    $scope.recordsEnd = function () {
        return Math.min($scope.requisitions.paging.pageLimit * ($scope.requisitions.paging.page + 1), $scope.$parent.requisitions.notesCount);
    };

    //Method for concatenating the User names
    $scope.concatenate = function (arr, separator) {
        separator = separator || ',';
        var str = '';
        angular.forEach(arr, function (value) {
            str = str + separator + value.fullName;
        });
        return str = str.substr(1);
    };

    /*
     * Loading more notes if notes more than 20
     */
    $scope.loadMoreNotes = function () {
        var data = {
            id: $scope.params.id,
            offset: $scope.requisitions.notes.length
        };
        data.count = $scope.requisitions.notesCount - data.offset;
        if (data.count > $scope.maxCount) {
            data.count = $scope.maxCount;
        }

        $scope.flags.loading = true;
        Reqs.notes(data, function (response) {
            $scope.requisitions.notes = $scope.requisitions.notes.concat(response.notes);
            $scope.flags.loading = false;
        });
    };
}
]);
